import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  FormField,
  FormFieldLabel,
  Input,
  RichTextEditor,
} from '@eureca/ui';

export type FaqDialogMode = 'add' | 'edit';

export interface AddFaqDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  mode: FaqDialogMode;
  question: string;
  answer: string;
  onQuestionChange: (value: string) => void;
  onAnswerChange: (value: string) => void;
  onSave: () => void;
}

export function AddFaqDialog({
  open,
  onOpenChange,
  mode,
  question,
  answer,
  onQuestionChange,
  onAnswerChange,
  onSave,
}: AddFaqDialogProps) {
  const title = mode === 'edit' ? 'Editar pergunta' : 'Adicionar nova pergunta';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="gap-0 lg:max-w-[423px]">
        <DialogHeader className="px-6 pt-6">
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        <form
          className="flex flex-col gap-5 px-6 pt-3 pb-8"
          onSubmit={(event) => {
            event.preventDefault();
            onSave();
          }}
          noValidate
        >
          <FormField>
            <FormFieldLabel>Pergunta</FormFieldLabel>
            <Input
              value={question}
              onChange={(event) => onQuestionChange(event.target.value)}
              placeholder="Ex.: Faço curso técnico posso participar?"
            />
          </FormField>

          <FormField>
            <FormFieldLabel>Resposta</FormFieldLabel>
            <RichTextEditor value={answer} onChange={(html) => onAnswerChange(html)} />
          </FormField>

          <DialogFooter className="px-0 pb-0">
            <DialogClose asChild>
              <Button type="button" variant="outline">
                Cancelar
              </Button>
            </DialogClose>
            <Button type="submit">Salvar</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
